module.exports = __webpack_public_path__ + "static/media/bg_quiz.3d1a6641.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_quiz.png
// module id = 1256
// module chunks = 0